import { pathOr } from 'ramda';
import { ICreateMessageResponseError } from '../../../repositories/demand/v4/create-message';

const SUBMIT_ERROR_DEFAULT = 'Что-то пошло не так. Попробуйте отправить заявку еще раз';

/**
 * Если error - 400 ошибка из апи, вернет message из нее
 * иначе вернет стандартный текст ошибки
 * */
export const getErrorMessageFromError = (error: ICreateMessageResponseError | unknown): string => {
  return pathOr(SUBMIT_ERROR_DEFAULT, ['errors', 0, 'message'], error);
};
